<template>
  <div class="churn-goodbye-page">
    <alert-page :emoji="'👌'"
                :title="'החשבון וכל הפרטים הקשורים אליו ימחקו תוך 48 שעות.'"
                :showButton="false"
                :show-support-footer="true">
      <template v-slot:content>
        <div class="bold">חשוב לנו להשתפר ולשפר את השירות!</div>
        <div>נשמח לדעת איך הייתה החוויה בשירות ולמה החלטת לעזוב. זה ייקח פחות מדקה.</div>
        <div class="button-container">
          <riseup-button class="survey-button"
                         :title="'לסקר'"
                         :variant="'secondary'"
                         :action="startSurvey"/>
        </div>
      </template>
    </alert-page>
  </div>
</template>

<script>
import BaseUI from 'base-ui';

import AlertPage from '../../../../base-components/AlertPage.vue';

export default {
  name: 'ChurnGoodbyePage',
  props: {
    startSurvey: {
      type: Function,
      require: true,
    },
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
    AlertPage,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .churn-goodbye-page {
    .bold {
      font-weight: bold;
    }

    .button-container {
      padding: 28px 0 42px 0;

      .survey-button {
        height: 72px;
        width: 297px;
      }
    }
  }
</style>
